const myclass = {
  path: 'myclass',
  meta: { index: 1 },
  component: resolve => require(['../../../../../components/pages/student_user/student/myclass'], resolve)
}
export default myclass



// WEBPACK FOOTER //
// ./src/router/pages/student_user/student/myclass/index.js